// AIS staleness semantics shared by the fleet map and the rig-modal mini-map.
// Positions are aggregator-scraped 'reported' data (ADR-0007 advisory); msgTime is the
// AIS broadcast time, which for stacked rigs can be months old.

export const FRESH_DAYS = 7;

/** "3 h ago" / "12 days ago" / null when undated or unparsable. */
export function agoLabel(iso: string | null): string | null {
  if (!iso) return null;
  const ms = Date.now() - Date.parse(iso);
  if (Number.isNaN(ms)) return null;
  const hours = Math.floor(ms / 3_600_000);
  if (hours < 1) return 'within the hour';
  if (hours < 48) return `${hours} h ago`;
  return `${Math.floor(hours / 24)} days ago`;
}

/** Solid vs hollow marker: stale = older than FRESH_DAYS, undated, or unparsable. */
export function isStale(msgTime: string | null): boolean {
  if (!msgTime) return true;
  const ms = Date.now() - Date.parse(msgTime);
  return Number.isNaN(ms) || ms > FRESH_DAYS * 86_400_000;
}
